import { InvestigationStatus } from '../utils/constants';

import type { GetFilesPayload } from './files.api';
import type { Inquiry, Insight, Investigation, RawFile } from './files.types';

export const normalizeFile = (file: RawFile): Investigation | Insight | Inquiry => {
  if (file.fileType === 'investigation') {
    return {
      ...file,
      fileDetails: {
        title: file.data.traceName,
        username: file.data.scope?.userName ?? null,
        host: file.data.scope?.systemName ?? null,
        ip: file.data.scope?.ipAddress ?? null,
        startDate: file.data.dateFrom,
        endDate: file.data.dateTo,
      },
      status: file.data.status,
      findings: {
        totalFindings: file.data.outcome?.totalFindingsFound ?? null,
        totalEvents: file.data.outcome?.totalRawProcessed ?? null,
        numberOfInsights: { ...file.data.numberOfInsights },
      },
    };
  }
  if (file.fileType === 'inquiry') {
    return {
      ...file,
      fileDetails: {
        title: file.data.name,
        username: file.data.criteria.user_name,
        startDate: file.data.dateFrom,
        endDate: file.data.dateTo,
      },
      status: file.data.status,
      findings: {
        totalFindings: file.data.inquiryTrace?.totalActivitiesFound ?? null,
        totalEvents: file.data.inquiryTrace?.totalFindingsFound ?? null,
      },
    };
  }

  return {
    ...file,
    fileDetails: {
      title: file.data.name,
      startDate: file.data.dateTo,
      endDate: file.data.dateFrom,
    },
    status: InvestigationStatus.COMPLETED, // insights are always completed as they are generated from completed investigations
    findings: {
      totalFindings: file.data.totalFindingsFound ?? null,
    },
  };
};

export const serializeGetFilesQueryArgs = (queryArgs: GetFilesPayload): string => {
  const { page, size, forCurrentUser, filters, timeAmount, timeUnit, sort } = queryArgs;

  const sortedFilters = Object.fromEntries(Object.entries(filters ?? {}).sort(([a], [b]) => a.localeCompare(b)));

  return `getFiles-${page}-${size}-${forCurrentUser}-${timeAmount}-${timeUnit}-${JSON.stringify(sortedFilters)}-${JSON.stringify(sort ?? null)}`;
};
